<template lang="pug">
  div
    header-without-menu
    div.content.access.join(:class="{loaded}")
      div.center-form.join-form
        div.text-center
          div: img(src="../../../assets/main_logo_b.png")
          div.mt-4.mb-3(v-html="$t('join_description')")
      div.join-done-main-img
        div.join-done-main-img-message(v-html="$t('free_trial_message')")
      div.button-wrap
        b-btn.w-100(variant="primary", :to="{name: 'login'}") {{$t('go_login')}}
</template>

<script>
import { HeaderWithoutMenu } from '../../mixins/header'
export default {
  name: 'join-done-component',
  components: { HeaderWithoutMenu },
  mounted () {
    this.loaded = true
  },
  data () {
    return {
      loaded: false
    }
  }
}
</script>

<style lang="scss" scoped src="../access.scss"></style>
<style lang="scss" scoped>
.loaded .join-form {
  margin-top: 20px;
}
.button-wrap {
  width: 90%;
  max-width: 460px;
  margin: 0 auto;
}
</style>
<style lang="scss">
.join-done-main-img {
  position: relative;
  height: 550px;
  background: url(../../../assets/link_join_done.png) no-repeat center;

  strong {
    display: block;
    color: #4fddc5;
    font-size: 26px;
  }

  .join-done-main-img-message {
    position: absolute;
    top: 50%; left: 0;
    width: 100%;
    margin-top: -60px;
    text-align: center;
  }
}
</style>
